import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { api } from "../lib/api";
import { Printer, ArrowLeft } from "@phosphor-icons/react";
import { PUBLIC_FRONT_URL } from "../lib/publicFront";

const FRONTEND_BASE = PUBLIC_FRONT_URL;

export default function PrintSheet() {
  const [params] = useSearchParams();
  const ids = (params.get("ids") || "").split(",").filter(Boolean);
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/codes");
        const all = data.codes || [];
        const filtered = ids.length
          ? all.filter((c) => ids.includes(c.id))
          : all.filter((c) => c.status !== "activated"); // by default print all not-yet-activated
        setCodes(filtered);
      } finally {
        setLoading(false);
      }
    })();
  }, []); // eslint-disable-line

  if (loading) return <div className="p-8 label-tag">Loading…</div>;

  return (
    <div className="bg-white">
      {/* Toolbar — hidden in print */}
      <div className="no-print sticky top-0 bg-white border-b border-black z-10" data-testid="print-toolbar">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
          <Link to="/admin/dashboard" className="label-tag inline-flex items-center gap-2">
            <ArrowLeft size={14} weight="bold" /> Back to dashboard
          </Link>
          <div className="label-tag text-neutral-600">{codes.length} cards · A4 sheet · 8 per page</div>
          <button onClick={() => window.print()} className="bg-black text-white label-tag px-5 py-3 brutal-btn flex items-center gap-2" data-testid="print-now-btn">
            <Printer size={16} weight="bold" /> Print / Save as PDF
          </button>
        </div>
        <div className="max-w-5xl mx-auto px-6 pb-4 text-xs text-neutral-600">
          Tip: when the print dialog opens, choose <strong>"Save as PDF"</strong> as your printer if you just want a file. On A4 paper this prints {codes.length} cards across {Math.ceil(codes.length / 8)} sheet{Math.ceil(codes.length / 8) === 1 ? "" : "s"}.
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 py-8">
        <div className="print-sheet grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="print-grid">
          {codes.map((c) => (
            <div key={c.id} className="card-cell border border-black p-3 break-inside-avoid">
              <div className="flex items-center justify-between mb-2">
                <span className="font-display font-black text-sm tracking-tight">CURB CREW</span>
                <span className="font-mono-cc text-[10px]">{c.code}</span>
              </div>
              <div className="bg-white grid place-items-center p-1">
                <QRCodeSVG value={`${FRONTEND_BASE}/c/${c.code}`} size={140} level="H" includeMargin={false} />
              </div>
              <div className="mt-2 text-[10px] text-neutral-700 font-mono-cc text-center break-all">
                {FRONTEND_BASE.replace(/^https?:\/\//, "")}/c/{c.code}
              </div>
              <div className="mt-1 text-[9px] text-neutral-500 text-center label-tag">Scan to view profile</div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          @page { size: A4; margin: 12mm; }
          body { background: white; }
          .print-sheet { gap: 8mm !important; }
          .card-cell { page-break-inside: avoid; break-inside: avoid; border: 1px solid #000 !important; }
        }
      `}</style>
    </div>
  );
}
